(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["belameur-home-seven"] && !Shopify.designMode) return;
  try {
    
function initBelameurSlides(root){
  root.querySelectorAll('.b7-slideshow').forEach(function(slideshow){
    if(slideshow.dataset.ready)return;
    slideshow.dataset.ready='true';
    const slides=Array.from(slideshow.querySelectorAll('.b7-slide'));
    const pause=slideshow.querySelector('[data-b7-pause]');
    let index=0,paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(next){
      index=(next+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        const active=i===index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',String(!active));
        slide.inert=!active;
      });
    }
    function label(){pause.textContent=paused?pause.dataset.playLabel:pause.dataset.pauseLabel;}
    label();
    slideshow.querySelector('[data-b7-prev]').addEventListener('click',()=>show(index-1));
    slideshow.querySelector('[data-b7-next]').addEventListener('click',()=>show(index+1));
    pause.addEventListener('click',()=>{paused=!paused;label();});
    const timer=setInterval(function(){
      if(!slideshow.isConnected){clearInterval(timer);return;}
      if(!paused&&!document.hidden&&!slideshow.matches(':hover')&&!slideshow.contains(document.activeElement))show(index+1);
    },5000);
  });
}
initBelameurSlides(document);
document.addEventListener('shopify:section:load',event=>initBelameurSlides(event.target));
document.addEventListener('click',function(event){
  const trigger=event.target.closest('[data-b7-chat]');
  if(!trigger)return;
  const inbox=document.querySelector('shopify-chat');
  const chatButton=inbox?.shadowRoot?.querySelector('button[part="activator"]');
  if(chatButton){
    if(chatButton.getAttribute('aria-expanded')!=='true')chatButton.click();
    const fallback=trigger.closest('.b7-service')?.querySelector('.b7-chat-fallback');
    if(fallback)fallback.hidden=true;
    return;
  }
  const fallback=trigger.closest('.b7-service')?.querySelector('.b7-chat-fallback');
  if(fallback)fallback.hidden=false;
});

  } catch(e) { console.error(e); }
})();
})();
